import type { PrimitiveType } from 'react-intl';
import type { ValuationClaimHolderKind } from '@immo/api-contract';

/**
 * The ONE source of the assignee label wherever a claim holder renders — the
 * queue cell, the queue's free-text search haystack, the detail's assignee line
 * and the release-claim confirmation heading (IMM-572.2). Composing inline at
 * any of those sites is the defect this helper exists to prevent: the search
 * haystack is easy to miss, and a composed label that skips it makes
 * machine-held rows unfindable by the term the operator can see on screen.
 *
 * `t` MUST be bound to `pages.admin.valuations` — the two label keys live at
 * that parent namespace so the queue page (which cannot reach `detail.*` keys)
 * and the detail page (via its `tTitle` binding) both resolve them.
 *
 * Returns null for an unclaimed request so each caller keeps its own empty
 * state (`unassigned` on the queue, `not-provided` on the detail).
 */
export function claimHolderLabel(
  kind: ValuationClaimHolderKind | null,
  name: string | null,
  t: (key: string, values?: Record<string, PrimitiveType>) => string,
): string | null {
  if (kind === 'ADMIN_API_KEY') {
    return name === null ? t('admin-key-holder-unknown') : t('admin-key-holder', { name });
  }

  return name;
}
